import React from 'react'
import _ from 'underscore';
// AppActions, App Actions, app-actions, appActions

const AppActions = (props) => {
    const childBlocks = _.values(props.blocks).map((Block, id) => <Block.component context={props.context} key={id}/>);

    if (childBlocks.length > 0) {
        return (
            <category name='App Actions' id='appActions' iconclass='category with-icon-paths snap-icon-app_action_dual'>
                <label text="App Actions"/>,
                { childBlocks }
            </category>
        );
    }

    return null;
};

export default AppActions;